var styles = {
  "Series": "_Series_1mcj1_1"
};

export { styles as default };
